import { isProduction } from "settings";
import log from "loglevel";
import { ErrorResponseType } from "types";

/**
 * Determine if user or operation is authenicated/authorized by checking
 * the result of the specified callback
 * @param isProduction
 * @param callback
 */
export const isAuthed = (
  authFunc: Promise<boolean>,
  fakeDefault?: boolean
): Promise<boolean> => {
  if (isProduction) {
    return authFunc;
  } else {
    if (fakeDefault === false) {
      return Promise.resolve(false);
    } else {
      return Promise.resolve(true);
    }
  }
};
